import { IContextMenuItem } from '@smartshell/ui-kit';

import { CtxMenuHost } from '../interfaces';
import { TGetPenaltyItems } from './interfaces';

export const getPenaltyItems: TGetPenaltyItems = ({
  t,
  permissions,
  isPenaltiesAvailable,
  openHostTimeDownModal,
  selectedHostsIds,
}) => {
  const timeDownItems: Array<IContextMenuItem<CtxMenuHost>> = [
    {
      key: 'timeDown-5',
      text: t('contracted.minutes', 5),
      iconName: 'FiveMinutesIcon',
      onClick: (host) => openHostTimeDownModal(host, 5),
    },
    {
      key: 'timeDown-10',
      text: t('contracted.minutes', 10),
      iconName: 'TenMinutesIcon',
      onClick: (host) => openHostTimeDownModal(host, 10),
    },
    {
      key: 'timeDown-15',
      text: t('contracted.minutes', 15),
      iconName: 'FifteenMinutesIcon',
      onClick: (host) => openHostTimeDownModal(host, 15),
    },
    {
      key: 'timeDown-30',
      text: t('contracted.minutes', 30),
      iconName: 'ThirtyMinutesIcon',
      onClick: (host) => openHostTimeDownModal(host, 30),
    },
  ];

  return !permissions?.has('host_command_manage')
    ? null
    : {
        key: 'penalty',
        text: t('host.ctx.penalty'),
        iconName: 'TimeDownIcon',
        subMenu: timeDownItems,
        disabled: ({ client_sessions, locked }) =>
          Boolean(
            !isPenaltiesAvailable ||
              !client_sessions ||
              !client_sessions.length ||
              locked ||
              client_sessions?.[0]?.postpaid ||
              (selectedHostsIds && selectedHostsIds?.length > 1)
          ),
      };
};
